import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../../../Layout/header';
import SuperAdminSidebar from './Sidebar';

const SuperAdminLayout = () => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  const toggleSidebar = () => {
    setIsCollapsed((prev) => !prev);
  };

  useEffect(() => {
    if (isCollapsed) {
      document.body.classList.add('sidebar-collapsed');
    } else {
      document.body.classList.remove('sidebar-collapsed');
    }

    return () => {
      document.body.classList.remove('sidebar-collapsed');
    };
  }, [isCollapsed]);

  return (
    <div className="flex h-screen bg-gray-50">
      <div className="fixed top-0 left-0 h-full bg-white shadow-md z-40">
        <SuperAdminSidebar isCollapsed={isCollapsed} onToggle={toggleSidebar} />
      </div>

      <div
        className="flex-1 flex flex-col transition-all duration-300 ease-in-out top-header-fix"
        style={{
          marginLeft: isCollapsed ? '60px' : '250px',
          width: isCollapsed ? 'calc(100% - 60px)' : 'calc(100% - 250px)',
        }}
      >
        <div className="sticky top-0 z-30">
          <Header />
        </div>

        <main className="flex-1 p-6 bg-gray-50">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default SuperAdminLayout;
